<template>
  <next-steps-base-card title="לבנות תוכנית אישית לשנים הבאות עם יועץ מומחה"
                        button-text="לפרטים על התוכנית"
                        description="ייעוץ אישי, בתשלום"
                        :action-key="actionKey"
                        @click="openAdvisoryFlow"/>
</template>

<script>
import { mapGetters } from 'vuex';
import NextStepsBaseCard from '../NextStepsBaseCard';
import { ActionKeys } from '../my-progress-next-steps.consts';

export default {
  name: 'AdvisoryNextStep',
  components: {
    NextStepsBaseCard,
  },
  data() {
    return {
      actionKey: ActionKeys.ADVISORY,
    };
  },
  computed: {
    ...mapGetters('advisory', ['advisoryFlowSharedUTMParams']),
  },
  methods: {
    openAdvisoryFlow() {
      this.$router.push({
        path: '/advisory-plan',
        query: {
          ...this.advisoryFlowSharedUTMParams,
          utm_content: 'menu-item',
          utm_campaign: 'my-progress',
        },
      });
    },
  },
};
</script>

<style scoped>

</style>
